import { getApi } from './../../../src/ts/libs/getApi';

const searchList = document.getElementsByClassName('search-results-list');

if (searchList[0]) {
  const PRODUCT_SEARCH_API_URL = getApi('productSearch');

  fetch(PRODUCT_SEARCH_API_URL, {
    headers: { 'content-type': 'application/json' },
  })
    .then((response) => response.json())
    .then(function (apiData) {
      displayProducts(apiData.products);
    });
}

function displayProducts(productData) {
  const productTotalLabel = document.getElementsByClassName('search-result-controls__total--int');
  const paginationLabel = document.getElementsByClassName('pagination__text');
  const paginationProgressBar = document.getElementsByClassName('pagination__indicator__bar') as any;
  const productWrapper = document.getElementsByClassName('product-card-grid');
  let productsList = '';

  productTotalLabel[0].innerHTML = productData.total;
  paginationLabel[0].innerHTML = `Showing ${productData.per_page} of ${productData.total}`;
  paginationProgressBar[0].style.width = (100 / productData.total_pages) * productData.page + '%';

  for (let i = 0; i < productData.items.length; i++) {
    const prod = productData.items[i];

    const productHtml = `
                <a class="product-card" href="${prod.url}">
                    <div class="product-card__header">
                        <span class="pill product-card__pill">
                            ${prod.stock}
                        </span>

                        <picture class="product-card__image">
                            <img src="${prod.image.url}" alt="${prod.image.alt}" title="${prod.image.title}>
                        </picture>

                        <h3 class="product-card__heading">${prod.name}</h3>
                    </div>
                    <p class="product-card__price">
                        <strong class="product-card__price__value">${prod.price}</strong>
                        <span class="product-card__price__vat">${prod.exclVat ? 'Ex VAT' : 'Inc VAT'}</span>
                    </p>
                    <span class="button button--muted product-card__action">
                        <span class="button__label">View details</span>
                    </span>
                </a>
            `;

    productsList = productsList + productHtml;

    productWrapper[0].innerHTML = productsList;
  }
}
